module.exports = __webpack_public_path__ + "static/img/3.730f3fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/3.png
// module id = HrO3
// module chunks = 0